import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./Badge.scss";
import { pickOverlayColor } from "../../../utils/colorUtils";

export const Badge = ({ fill, size, spacing, color, customColor, number, place, children }) => {
    return (
        <span
            className={classNames(styles.base, {
                [styles.colorPrimary]: color === "primary",
                [styles.colorAccent]: color === "accent",
                [styles.colorInfo]: color === "info",
                [styles.colorSuccess]: color === "success",
                [styles.colorWarning]: color === "warning",
                [styles.colorError]: color === "error",
                [styles.colorContrast]: color === "contrast",
                [styles.colorSilent]: color === "silent",

                [styles.sizeSmall]: size === "small",

                [styles.placeCorner]: place === "corner",

                [styles.spacingLeft]: spacing && spacing.indexOf("left") >= 0,
                [styles.spacingRight]: spacing && spacing.indexOf("right") >= 0,

                [styles.fill]: fill,
                [styles.number]: number
            })}
            style={
                customColor
                    ? {
                          [fill ? "backgroundColor" : null]: customColor,
                          color: fill ? pickOverlayColor(customColor, "#ffffff", "#000000") : customColor,
                          borderColor: customColor
                      }
                    : null
            }
        >
            {children}
        </span>
    );
};

Badge.propTypes = {
    /**
     * Fill with solid color
     */
    fill: PropTypes.bool,
    /**
     * Change size of badge
     */
    size: PropTypes.oneOf(["small"]),
    /**
     * Set color of bage
     */
    color: PropTypes.oneOf(["primary", "accent", "info", "success", "warning", "error", "contrast", "silent"]),
    /**
     * Add a custom color
     */
    customColor: PropTypes.string,
    /**
     * Adapt to display number
     */
    number: PropTypes.bool,
    /**
     * Add spacing to badge (left/right)
     */
    spacing: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    /**
     * Content of badge
     */
    children: PropTypes.any
};
